import favouritesReducer from './favourites.reducer';
export * from './favourites.selectors';
export default favouritesReducer;
